import "../styles/Myİnfo.css"
export const Myİnfo = () => {
    return(
        <div id="my-info">
        <p className='fs-4'>
            Merhabalar Ben Necati Efe Hançer Aslen Sivas Gürün Doğumluyum
            küçüklükten beri yazılım dünyasına ilgi ve alakam var lise döneminden sonra
            bu alandaki ilgilerimi mesleğe dökmek istedim ve yazılım mühendisliği bölümünde eğtim almaktayım
            Aslen sivaslı olup sivasta ikamet etmekteyim birçok alanda kendimi geliştirip çalışmalarda bulundum
            ve şu anda  HeraSystem`i Kurdum Birçok projelerim Bulunmakta iletişime geçmek için Allttaki Adreslerden Bana Ulaşabilirsiniz
        </p>
        <img src='images/file.jpg' id='my-image' />
    </div>
    )
}